<template>
<v-card flat >
  <v-list>
    <v-list-tile >
      <v-list-tile-content>
        <v-list-tile-title>{{program.name}}</v-list-tile-title>
        <v-list-tile-sub-title>
          {{ dateformat(program.start_date) }} - {{ dateformat(program.end_date) }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
  <v-tabs v-model='activeTab' >
    <v-tab ><v-icon>home</v-icon></v-tab>
    <v-tab >Exercises</v-tab>
    <v-tab >Progress</v-tab>
    <v-tab >Messages</v-tab>
    <v-tabs-items v-model='activeTab' >
      <v-tab-item >
        <v-subheader class="overline" >Settings</v-subheader>
        <v-card flat >
          <v-card-text >
          <v-checkbox v-model='program.track_adherence' label='Track adherence' class='ma-0 pa-0' readonly ></v-checkbox>
          <v-checkbox v-model='program.track_pain_levels' label='Track pain levels' class='ma-0 pa-0' readonly ></v-checkbox>
          <div>
            <strong>Access code sent:</strong> {{ dateformat(program.access_code_sent_date) }} via {{program.access_code_sent_via}}<br/>
            <strong>Last accessed:</strong> {{ dateformat(program.last_access_date) }}
          </div>
          </v-card-text>
          <v-subheader class="overline" >Access details</v-subheader>
          <v-card-text >
            <copy-text-field
              label='Share this url with you client so that they can access Physitrack'
              v-if='programUrl'
              :text-to-copy='programUrl' >
            </copy-text-field>
            <strong>Access code:</strong> <code>{{program.access_code }}</code><br/>
            <strong>Date of birth:</strong> {{ dateOfBirth }}
          <!-- {{program}} -->
          </v-card-text>
        </v-card>
        <!-- <pre>{{program}}</pre> -->
      </v-tab-item>
      <v-tab-item >
        <template v-if='requests.exercises.loading' >
          <tombstone v-if='!exercises || exercises.length === 0' ></tombstone>
          <v-progress-linear v-else indeterminate class='ma-0' :height='1' >
          </v-progress-linear>
        </template>
        <v-list >
          <template v-for='(exercise, index) in exercises' >
            <exercise-list-item
              v-model='exercises[index]'
              :key='`ex-${exercise.id}-${index}`' >
            </exercise-list-item>
            <v-divider :key='`div-exercises-${exercise.id}-${index}`' ></v-divider>
          </template>
        </v-list>
      </v-tab-item>
      <v-tab-item >
        <v-layout v-if='requests.adherence.loading' >
          <v-flex xs12>
            <tombstone v-if='!progress || !progress.days' ></tombstone>
            <v-progress-linear v-else indeterminate class='ma-0' :height='1' >
            </v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout >
          <v-flex xs4 class='grey lighten-4' >
            <v-list class='pa-0' v-if='progress && progress.days' dense >
              <template v-for='day in progress.days' >
                <v-list-tile @click='selectedDate=day.date' :key='day.date' >
                  <v-list-tile-avatar >
                    <adherence-progress v-model='day.avg_day_adherence' ></adherence-progress>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ dateformat(day.date) }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action >
                    <!-- <v-chip dark color='error' class='v-chip--x-small' >
                      Pain: </v-chip> -->
                      <v-icon>chevron_right</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
                <v-progress-linear :value='day.avg_day_adherence'
                  :key='`div-${day.date}`'
                  height='1' class='ma-0' >
                </v-progress-linear>
              </template>
            </v-list>
          </v-flex>
          <v-divider vertical ></v-divider>
          <v-flex xs8 >
            <v-toolbar v-if='progressDetail' dense flat >
              <v-toolbar-title>{{ dateformat(selectedDate) }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <adherence-progress v-model='progressDetail.avg_day_adherence' >
              </adherence-progress>
            </v-toolbar>
            <template v-if='progressDetail && progressDetail.exercises' >
            <v-list dense three-line>
              <template v-for='(exercise, index) in progressDetail.exercises'  >
                <exercise-list-item v-model='progressDetail.exercises[index]' :key='`prog-${exercise.id}-${index}`' >
                </exercise-list-item>
                <v-divider :key='`div-${exercise.id}-${index}`' ></v-divider>
              </template>
              <v-list-tile v-if='progressDetail.exercises.length === 0' >
                <v-list-tile-content>
                  <v-list-tile-title>
                    No exercises completed
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            </template>
            <!-- <pre>{{progressDetail}}</pre> -->
          </v-flex>
        </v-layout>
        <!-- <pre>{{progress}}</pre> -->
      </v-tab-item>
      <v-tab-item >
        <template v-if='requests.messages.loading' >
          <tombstone v-if='!messages || messages.length === 0' ></tombstone>
          <v-progress-linear v-else indeterminate class='ma-0' :height='1' >
          </v-progress-linear>
        </template>
        <messages
          @new='getMessages'
          :physitrack-client-id='physitrackClientId'
          :messages='messages' >
        </messages>
        <!-- <pre>{{messages}}</pre> -->
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
  <!-- <v-card-text>
    <p>{{program.description}}</p>
    <pre>{{program}}</pre>
  </v-card-text> -->
  <v-alert disabled outlined outline small :value='true'
    v-if='requests.send.status === 409' type='error' >
    {{requests.send.errors.errors}}
  </v-alert >
  <v-divider></v-divider>
  <v-card-actions >
    <v-spacer></v-spacer>
    <v-btn small
      v-if='requests.send.status !== 200'
      :disabled='!program.access_code'
      :loading='requests.send.loading'
      @click='send(program.access_code)' >
      Send <v-icon class='ml-2' small>send</v-icon>
    </v-btn>
    <v-btn disabled outlined outline small
      v-if='requests.send.status === 200' color='success' >Sent</v-btn>

    <v-btn small
      :loading="downloading"
      @click='download(program.access_code)' >
      <v-icon small class='mr-2'>cloud_download</v-icon> Download PDF
    </v-btn>
    <v-btn small
      :href='program.sso_url' target="_blank"  >
      Open Program <v-icon small class="ml-2">open_in_new</v-icon>
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import {DateTime} from 'luxon'
import Tombstone from '@/components/app/Tombstone'
import ExerciseListItem from './ExerciseListItem.vue'
import AdherenceProgress from './AdherenceProgress.vue'
import Messages from './Messages.vue'
import CopyTextField from '@/components/ui/CopyTextField'
import axios from 'axios'
export default {
  name: 'Program',
  components: {CopyTextField, ExerciseListItem, AdherenceProgress, Messages, Tombstone},
  props: {
    value: { type: Object, required: true },
    physitrackClientId: { required: true },
    dateOfBirth: { required: true }
  },
  data () {
    return {
      program: {},
      activeTab: 0,
      selectedDate: null,
      downloading: false,
      requests: {
        send: {
          resource: 'ag.integrations',
          extra: 'physitrack/program',
          result: {},
          status: 0
        },
        exercises: {
          resource: 'ag.integrations',
          extra: 'physitrack/program_exercises',
          result: {}
        },
        adherence: {
          resource: 'ag.integrations',
          extra: 'physitrack/adherence',
          result: {}
        },
        messages: {
          resource: 'ag.integrations',
          extra: 'physitrack/messages',
          result: {}
        }
      }
    }
  },
  mounted () {
    this.selectedDate = DateTime.local().toISODate()
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.program = this.value }
      }
    },
    activeTab () {
      if (this.activeTab === 1) {
        this.getExercises()
      }
      if (this.activeTab === 2) {
        this.getAdherence()
      }
      if (this.activeTab === 3) {
        this.getMessages()
      }
    }
  },
  methods: {
    getAdherence () {
      this.requests.adherence.params = this.programParams
      this.$request('get', this.requests.adherence)
    },
    getExercises () {
      this.requests.exercises.params = this.programParams
      this.$request('get', this.requests.exercises)
    },
    getMessages () {
      this.requests.messages.params = this.programParams
      this.$request('get', this.requests.messages)
    },
    send (accessCode) {
      this.requests.send.params = {
        client_id: this.physitrackClientId,
        access_code: accessCode,
        suffix: 'resend'
      }
      this.$request('get', this.requests.send)
    },
    download (accessCode) {
      let path = '/api/v2/practitioner/integrations/physitrack/program/'
      let url = `${this.$appointmentguru.baseUrl}${path}`
      let method = 'GET'
      let headers = this.$appointmentguru.headers
      let params = {
        client_id: this.physitrackClientId,
        access_code: accessCode,
        pdf: true
      }
      headers['Content-Type'] = 'application/pdf'
      // headers['Accept'] = 'application/pdf'
      this.downloading = true
      axios({url, method, params, headers, responseType: 'arraybuffer'})
        .then((response) => {
          console.log(response.data)
          const url = window.URL.createObjectURL(new Blob([response.data], {'type': 'application/pdf'}))
          // const url = window.URL.createObjectURL(response.data)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'program.pdf')
          document.body.appendChild(link)
          link.click()
          this.downloading = false
        })
        .catch((err) => {
          console.error(err)
          window.alert('Unable to download pdf, please try again later')
        })
    }
  },
  computed: {
    progress () {
      return this.getObjectPath(this.requests.adherence, 'result', [])
    },
    exercises () {
      return this.getObjectPath(this.requests.exercises, 'result.exercises', [])
    },
    messages () {
      return this.getObjectPath(this.requests.messages, 'result.messages', [])
    },
    programUrl () {
      if (this.program) {
        return `https://uk.physiapp.com/access/${this.program.access_code}`
      }
      return null
    },
    programParams () {
      return {
        client_id: this.physitrackClientId,
        access_code: this.program.access_code
      }
    },
    progressDetail () {
      if (this.progress && this.progress.days) {
        return this.progress.days.find((day) => {
          return day.date.startsWith(this.selectedDate)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Program.vue?63da0ddf